var _g, _g2, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6575_47102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7048 30.1013V42.3536C26.7048 42.5279 26.8474 42.6703 27.0217 42.6703H31.5684C31.748 42.6703 31.8906 42.5279 31.8906 42.3536V29.9059H35.1912C35.3549 29.9059 35.4975 29.7792 35.5081 29.6155L35.8248 25.8656C35.8407 25.6808 35.6929 25.5175 35.5081 25.5175H31.8959V22.8558C31.8959 22.2273 32.4028 21.7253 33.026 21.7253H35.5661C35.7456 21.7253 35.8883 21.5829 35.8883 21.4086V17.6587C35.8883 17.4845 35.7456 17.3369 35.5661 17.3369H31.2728C28.7538 17.3369 26.71 19.3805 26.71 21.8996V25.5175H24.434C24.2544 25.5175 24.1172 25.6599 24.1172 25.8341V29.5835C24.1172 29.7578 24.2597 29.9007 24.434 29.9007H26.71V30.1013H26.7048Z",
    stroke: "#4867D6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6575_47102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#4867D6",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7048 30.1013V42.3536C26.7048 42.5279 26.8474 42.6703 27.0217 42.6703H31.5684C31.748 42.6703 31.8906 42.5279 31.8906 42.3536V29.9059H35.1912C35.3549 29.9059 35.4975 29.7792 35.5081 29.6155L35.8248 25.8656C35.8407 25.6808 35.6929 25.5175 35.5081 25.5175H31.8959V22.8558C31.8959 22.2273 32.4028 21.7253 33.026 21.7253H35.5661C35.7456 21.7253 35.8883 21.5829 35.8883 21.4086V17.6587C35.8883 17.4845 35.7456 17.3369 35.5661 17.3369H31.2728C28.7538 17.3369 26.71 19.3805 26.71 21.8996V25.5175H24.434C24.2544 25.5175 24.1172 25.6599 24.1172 25.8341V29.5835C24.1172 29.7578 24.2597 29.9007 24.434 29.9007H26.71V30.1013H26.7048Z",
    stroke: "#4867D6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#4867D6",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7048 30.1013V42.3536C26.7048 42.5279 26.8474 42.6703 27.0217 42.6703H31.5684C31.748 42.6703 31.8906 42.5279 31.8906 42.3536V29.9059H35.1912C35.3549 29.9059 35.4975 29.7792 35.5081 29.6155L35.8248 25.8656C35.8407 25.6808 35.6929 25.5175 35.5081 25.5175H31.8959V22.8558C31.8959 22.2273 32.4028 21.7253 33.026 21.7253H35.5661C35.7456 21.7253 35.8883 21.5829 35.8883 21.4086V17.6587C35.8883 17.4845 35.7456 17.3369 35.5661 17.3369H31.2728C28.7538 17.3369 26.71 19.3805 26.71 21.8996V25.5175H24.434C24.2544 25.5175 24.1172 25.6599 24.1172 25.8341V29.5835C24.1172 29.7578 24.2597 29.9007 24.434 29.9007H26.71V30.1013H26.7048Z",
    stroke: "#84FFFF",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#84FFFF",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6575_47102",
    x: 14.6172,
    y: 7.83691,
    width: 30.771,
    height: 44.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6575_47102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6575_47102",
    x: 0.879883,
    y: 0.879883,
    width: 58.2402,
    height: 58.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6575_47102"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLight);
export default __webpack_public_path__ + "static/media/facebook_light.2f169fcf7dda2fec91e57fa79e25f656.svg";
export { ForwardRef as ReactComponent };